export const gtagFuncCreator = (dataLayer) => {
  return (...args) => dataLayer.push(args)
}

export const GA4_ID = 'G-HJMZ53V9R3'

const configureGa4 = (gtag, debugMode) => {
  gtag('js', new Date())
  gtag('config', GA4_ID, { debug_mode: debugMode })
}

export const injectScriptIntoDOM = (debugMode) => {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    const dl = l !== 'dataLayer' ? `&l=${l}` : ''
    j.async = true
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`
    f.parentNode.insertBefore(j, f)
  }(window, document, 'script', 'dataLayer', 'GTM-PMZC62P'))

  configureGa4(gtagFuncCreator(window.dataLayer), debugMode)
}

export const injectGa4Only = (debugMode) => {
  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`
  document.head.appendChild(script)

  // gtag.js ignores dataLayer entries that are arrays; it needs the `arguments` object
  // eslint-disable-next-line prefer-rest-params
  configureGa4(function gtag() { window.dataLayer.push(arguments) }, debugMode)
}

export const loadGtm = (injectScript = injectScriptIntoDOM) => {
  window.dataLayer = window.dataLayer || []

  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  })

  if (!window.location.href.includes('ahaslides.eu') && params.tracking !== 'false') {
    let debugMode = true
    if (window.location.href.includes('ahaslides.com')) {
      debugMode = false
    }
    injectScript(debugMode)
  }
}
